













import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    paused: {
      type: Boolean,
      required: false,
      default: true
    },
    videoShown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    icons() {
      return {
        play: faPlay,
        pause: faPause
      }
    }
  }
})
